import {AfterContentChecked,AfterContentInit,ChangeDetectorRef,Component,ComponentRef,OnDestroy,OnInit} from '@angular/core';
import {Subscription} from 'rxjs';

export abstract class AbstractComponent implements OnInit, OnDestroy, AfterContentChecked, AfterContentInit {
    protected _subs:Subscription[] = [];

    constructor(
        protected _cd:ChangeDetectorRef,
    ) { }

    public ngOnInit() {
    }

    public ngOnDestroy() {
        for(let sub of this._subs) {
            sub.unsubscribe();
        }
    }

    public ngAfterContentInit(): void {
        this._markForCheckComponentRef();
    }
    public ngAfterContentChecked(): void {
        this._markForCheckComponentRef();
    }

    public set addSub(sub:Subscription) {
      this._subs.push(sub);
    }

    public markForCheck() {
        this._cd.markForCheck();
        this._markForCheckComponentRef();
    }

    protected _markForCheckComponentRef() {
        for(let compoRef of this._getListComponentRef()) {
            compoRef.changeDetectorRef.markForCheck();
        }
    }

    // TODO : vérifier la pertinence et l'efficacité de ce code
    protected _getListComponentRef():ComponentRef<Component>[] {
        let list:ComponentRef<Component>[] = [];

        for(let elemName of Object.keys(this)) {
            if(this[elemName] != undefined && this[elemName] != null && this[elemName].constructor.name == 'ComponentRef_') {
                list.push(this[elemName]);
            }
        }

        return list;
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/shared/models/abstract-component.ts